<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";
import Dashboard from "./CommissionAppProcessing/Dashboard.vue";
import ListConfStatements from "../Tabs/TabsInConfDeanExWork/ListConfStatements";
import CardListApplicants from "../Cards/Commissions/CardListApplicants.vue";
import CardListStatements from "../Cards/Commissions/CardListStatements.vue";
import CardPinning from "../Cards/Commissions/CardPinning.vue";
import WorkingWithOrders from "../Tabs/TabsInConfDeanExWork/WorkingWithOrders";
import {RouterLink, RouterView} from "vue-router";

export default {
  name: "ConfDirectorCampus",
  data: () => ({
    status_place: null,
    active_place_hostel: {
      name_hostel: '',
      name_section: '',
      room_id: '',
      name_room: '',
      room_info: {}
    },
    drawer_left: false,
    statuses_place: [
      {text: 'Комната пустая', color: 'grey'},
      {text: 'Комната заполнена', color: 'green'},
      {text: 'Комната частично заполнена', color: 'orange'},
    ],
    tabs_residents: '',
    tabs_layouts: ''
  }),
  components: {
    Dashboard,
    ListConfStatements,
    CardListApplicants,
    CardListStatements,
    CardPinning,
    WorkingWithOrders,
    RouterLink,
    RouterView,
  },
  mounted() {
    // this.IndexApplicants().then(() =>
    //     this.GetListDepartmentStatements().then(() =>
    //         this.count_statements()
    //     ));
  },
  computed: {
    ...mapState({
      current_hostels: state => state.placesInDormitories.current_hostels,
      list_statements: state => state.interactionStatement.list_statements,
      selected_place: state => state.placesInDormitories.selected_place,
      result_data_statements: state => state.interactionStatement.result_data_statements,
      status_conf: state => state.interactionStatement.status_conf,
      stm_applicants: state => state.interactionStatement.stm_applicants,
      distribution_places: state => state.placesInDormitories.distribution_places,
      list_distribution_hostel_statements: state => state.interactionStatement.list_distribution_hostel_statements,
    }),
    ...mapGetters({
    }),
    filter() {
      if (this.status_place === "Пустые комнаты") {
        return (item) => item.mark_color === 'grey'
      } else if (this.status_place === "Занятые комнаты") return (item) => item.mark_color === 'green'
      else if (this.status_place === "Частично заполненные комнаты") return (item) => item.mark_color === 'orange'

    },
    items_load() {
      return this.distribution_places.places
    },
  },
  watch: {
    active_place_hostel: {
      handler(){
        this.setResetDataStates()
      },
      deep: true,
    }
  },
  methods: {
    ...mapMutations({
      setDormitory: 'placesInDormitories/setDormitory',
      setSection: 'placesInDormitories/setSection',
      setRoom: 'placesInDormitories/setRoom',
      setResetDataStates: 'interactionStatement/setResetDataStates',
      setPlaceResData: 'interactionStatement/setPlaceResData',
      setCountStatements: 'interactionStatement/setCountStatements',
    }),
    ...mapActions({
      GetDormFac: 'placesInDormitories/GetDormFac',
      GetListDepartmentStatements: 'interactionStatement/GetListDepartmentStatements',
      IndexApplicants: 'interactionStatement/IndexApplicants',
      ShowStatementsPlace: 'interactionStatement/ShowStatementsPlace',
    }),
    count_statements(){
      this.setCountStatements(this.list_statements.statement_hostels.length - _.intersectionBy(this.list_statements.statement_hostels, this.stm_applicants.stm_hostel_all, 'full_name').length)
    },
    setColorStPlace(room_info){
      if (room_info.occupied === room_info.total) return 'green'
      if (room_info.occupied !== 0) return 'orange'
      return 'grey'
    },
    setActivePlaceHostel(name_hostel, name_section, room_id, name_room, room_info){
      this.active_place_hostel.name_hostel = name_hostel
      this.active_place_hostel.name_section = name_section
      this.active_place_hostel.name_room = name_room
      this.active_place_hostel.room_info = room_info
      this.active_place_hostel.room_id = room_id

      this.setPlaceResData(this.active_place_hostel)

      this.ShowStatementsPlace(room_id) // Доработка подтягивания заявлений
    },
    // res_data_table() {
    //     if (this.active_place_hostel.name_room) {
    //         let set_conf_state_students = this.list_statements.statement_hostels.filter((state) =>
    //             state.result_place?.name_hostel === this.active_place_hostel.name_hostel &&
    //             state.result_place?.name_section === this.active_place_hostel.name_section &&
    //             state.result_place?.name_room === this.active_place_hostel.name_room &&
    //             state.dean_ex_work_confirm === 2
    //         )
    //         let set_conf_state_applicants = this.stm_applicants.stm_hostel_all.filter((state) =>
    //             state.result_place?.name_hostel === this.active_place_hostel.name_hostel &&
    //             state.result_place?.name_section === this.active_place_hostel.name_section &&
    //             state.result_place?.name_room === this.active_place_hostel.name_room &&
    //             state.dean_ex_work_confirm === 2
    //         )
    //         let res_statements = _.unionBy(set_conf_state_students, set_conf_state_applicants, 'full_name')
    //         if (res_statements.length !== 0) this.setResDataStates(res_statements)
    //     }
    // },
    placeSectionsSelect(name_hostel) {
      if (name_hostel === undefined || name_hostel === '' || name_hostel === null) return []
      let sections = _.filter(this.current_hostels, {'name_campus': name_hostel})[0]?.sections

      return sections
    },
    placeRoomsSelect(name_section, name_hostel) {
      if (!name_section || !name_hostel) return []
      let rooms = _.filter(this.placeSectionsSelect(name_hostel), {'name': name_section})[0]?.rooms

      return rooms
    },
    updateCurrentPlace(prop){
      this.active_place_hostel.room_info.occupied = prop.room_info_occupied
    }
  }
}
</script>

<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card outlined max-height="800px" class="rounded-xl mb-5">
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">
              Распределение студентов по местам в общежития
            </h6>
          </v-card-title>
<!--          <v-tabs-->
<!--            v-model="tabs_layouts"-->
<!--            class="px-4"-->
<!--            lign-with-title-->
<!--            fixed-tabs-->
<!--            show-arrows-->
<!--            color="teal accent-4"-->
<!--          >-->
<!--            <v-tab>Все заявления</v-tab>-->
<!--            <v-tab>Предпросмотр распредления</v-tab>-->
<!--            <v-tab>Работа с приказами</v-tab>-->
<!--          </v-tabs>-->
        </v-card>
        <router-view/>
<!--        <v-card elevation="0">-->
<!--          <v-tabs-items v-model="tabs_layouts">-->
<!--            <v-tab-item>-->
<!--              <v-card class="mt-4" outlined rounded="xl">-->
<!--                <v-subheader>МЕТКИ ФИЛЬТРА</v-subheader>-->
<!--                <v-row no-gutters>-->
<!--                  <div-->
<!--                    v-for="(item, i) in statuses_place"-->
<!--                    :key="i"-->
<!--                    class="ml-5"-->
<!--                  >-->
<!--                    <v-row no-gutters>-->
<!--                      <v-icon class="justify-center" :color="item.color" size="10px">fa fa-circle</v-icon>-->
<!--                      <div class="pl-2">{{ item.text }}</div>-->
<!--                    </v-row>-->
<!--                  </div>-->
<!--                </v-row>-->
<!--                <v-row class="mb-2 mx-2">-->
<!--                  <v-col cols="12" md="3">-->
<!--                    <v-sheet>-->
<!--                      <v-select-->
<!--                        v-model="status_place"-->
<!--                        :items="['Пустые комнаты','Занятые комнаты', 'Частично заполненные комнаты']"-->
<!--                        label="Фильтр комнат"-->
<!--                        dense-->
<!--                        outlined-->
<!--                        clearable-->
<!--                        hide-details-->
<!--                      ></v-select>-->
<!--                    </v-sheet>-->
<!--                  </v-col>-->
<!--                  <v-col cols="3">-->
<!--                    <v-select-->
<!--                      :value="selected_place.dormitory"-->
<!--                      @input="setDormitory"-->
<!--                      :items="current_hostels"-->
<!--                      item-text="name_campus"-->
<!--                      label="Общежитие"-->
<!--                      no-data-text="Данные отсутствуют"-->
<!--                      hide-details-->
<!--                      clearable-->
<!--                      dense-->
<!--                      outlined-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
<!--                  <v-col cols="3">-->
<!--                    <v-select-->
<!--                      :value="selected_place.section"-->
<!--                      @input="setSection"-->
<!--                      :items="placeSectionsSelect(selected_place.dormitory)"-->
<!--                      item-text="name"-->
<!--                      label="Секция"-->
<!--                      no-data-text="Данные отсутствуют"-->
<!--                      hide-details-->
<!--                      clearable-->
<!--                      dense-->
<!--                      outlined-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
<!--                  <v-col cols="3">-->
<!--                    <v-select-->
<!--                      :value="selected_place.room"-->
<!--                      @input="setRoom"-->
<!--                      :items="placeRoomsSelect(selected_place.section,selected_place.dormitory)"-->
<!--                      item-text="name"-->
<!--                      label="Комната"-->
<!--                      no-data-text="Данные отсутствуют"-->
<!--                      hide-details-->
<!--                      clearable-->
<!--                      dense-->
<!--                      outlined-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--              </v-card>-->
<!--              <v-row class="mt-2">-->
<!--                <v-col cols="12" md="8">-->
<!--                  <v-card outlined rounded="xl" class="overflow-hidden">-->
<!--                    <v-app-bar-->
<!--                      color="white"-->
<!--                    >-->
<!--                      <v-app-bar-nav-icon @click.stop="drawer_left = !drawer_left">-->
<!--                        <template v-slot:default>-->
<!--                          <v-icon small color="teal" dark>-->
<!--                            fa-list-ul-->
<!--                          </v-icon>-->
<!--                        </template>-->
<!--                      </v-app-bar-nav-icon>-->

<!--                      <v-toolbar-title class="text-h5">Заявления</v-toolbar-title>-->

<!--                      <template v-slot:extension>-->
<!--                        <v-tabs-->
<!--                          v-model="tabs_residents"-->
<!--                          color="teal"-->
<!--                          centered-->
<!--                        >-->
<!--                          <v-tab key="students">Студенты</v-tab>-->
<!--                          <v-tab key="applicants">Абитуриенты</v-tab>-->
<!--                        </v-tabs>-->
<!--                      </template>-->
<!--                    </v-app-bar>-->
<!--                    <v-tabs-items v-model="tabs_residents">-->
<!--                      <v-tab-item>-->
<!--                        <CardListStatements :active_place_hostel="active_place_hostel" />-->
<!--                      </v-tab-item>-->
<!--                      <v-tab-item>-->
<!--                        <CardListApplicants :active_place_hostel="active_place_hostel" />-->
<!--                      </v-tab-item>-->
<!--                    </v-tabs-items>-->
<!--                    <v-navigation-drawer-->
<!--                      class="rounded-xl"-->
<!--                      v-model="drawer_left"-->
<!--                      width="60%"-->
<!--                      touchless-->
<!--                      absolute-->
<!--                      bottom-->
<!--                      temporary-->
<!--                    >-->
<!--                      <template v-slot:prepend>-->
<!--                        <v-card elevation="0">-->
<!--                          <v-card-title>-->
<!--                            <div absolute class="mx-auto">-->
<!--                              Распределенные места факультета-->
<!--                            </div>-->
<!--                            <v-btn icon @click="drawer_left = !drawer_left">-->
<!--                              <v-icon>-->
<!--                                fa-angle-left-->
<!--                              </v-icon>-->
<!--                            </v-btn>-->
<!--                          </v-card-title>-->
<!--                          <v-divider/>-->
<!--                        </v-card>-->
<!--                      </template>-->
<!--                      <v-card elevation="0">-->
<!--                        <v-list nav dense expand>-->
<!--                          <v-list-item-group>-->
<!--                            <v-list-group-->
<!--                              v-for="(place, index) in items_load"-->
<!--                              active-class="teal&#45;&#45;text text&#45;&#45;accent-4"-->
<!--                              append-icon="fa-caret-down"-->
<!--                              :value="true"-->
<!--                              :key="index"-->
<!--                              color="teal"-->
<!--                              no-action-->
<!--                            >-->
<!--                              <template v-slot:activator>-->
<!--                                <v-list-item-title>{{ place.name_hostel }}</v-list-item-title>-->
<!--                              </template>-->
<!--                              <v-list-group-->
<!--                                active-class="teal&#45;&#45;text text&#45;&#45;accent-4"-->
<!--                                v-for="(section, index) in place.sections"-->
<!--                                :value="true"-->
<!--                                :key="index"-->
<!--                                color="teal"-->
<!--                                no-action-->
<!--                                sub-group-->
<!--                              >-->
<!--                                <template v-slot:activator>-->
<!--                                  <v-list-item-content>-->
<!--                                    <v-list-item-title>{{ section.name_section }}</v-list-item-title>-->
<!--                                  </v-list-item-content>-->
<!--                                </template>-->
<!--                                <v-list-item-->
<!--                                  v-for="(room, index) in section.rooms"-->
<!--                                  @click="setActivePlaceHostel(place.name_hostel, section.name_section, room.room_id, room.name_room, room.room_info), drawer_left = !drawer_left"-->
<!--                                  :key="index"-->
<!--                                  color="teal"-->
<!--                                  link-->
<!--                                >-->
<!--                                  <v-list-item-content>-->
<!--                                    <v-list-item-title v-text="room.name_room"></v-list-item-title>-->
<!--                                  </v-list-item-content>-->

<!--                                  <v-list-item-action>-->
<!--                                    <v-icon size="10px" :color="setColorStPlace(room.room_info)">-->
<!--                                      fa fa-circle-->
<!--                                    </v-icon>-->
<!--                                  </v-list-item-action>-->
<!--                                </v-list-item>-->
<!--                              </v-list-group>-->
<!--                            </v-list-group>-->
<!--                          </v-list-item-group>-->
<!--                        </v-list>-->
<!--                      </v-card>-->
<!--                    </v-navigation-drawer>-->
<!--                  </v-card>-->
<!--                </v-col>-->
<!--                <v-col cols="12" md="4">-->
<!--                  <CardPinning :active_place_hostel="active_place_hostel" @updateCurrentPlace="updateCurrentPlace"/>-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--            </v-tab-item>-->
<!--            <v-tab-item>-->
<!--              <ListConfStatements/>-->
<!--            </v-tab-item>-->
<!--            <v-tab-item>-->
<!--              <WorkingWithOrders/>-->
<!--            </v-tab-item>-->
<!--          </v-tabs-items>-->
<!--        </v-card>-->
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>

</style>